<template>
  <svg
    width="31"
    height="34"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3864 16.2533L16.3864 16.2533L10.9544 20.2367L11.5673 17.3156C11.7041 16.6632 11.2062 16.05 10.5396 16.05H6H0.75V0.75H12H16.1538H23.25V6.41667V11.6083V16.05H17.0073C16.784 16.05 16.5665 16.1212 16.3864 16.2533Z"
      stroke="white"
      stroke-width="1.5"
    />
    <circle cx="6.5" cy="8.5" r="1.5" fill="white" />
    <circle cx="11.5" cy="8.5" r="1.5" fill="white" />
    <circle cx="16.5" cy="8.5" r="1.5" fill="white" />
  </svg>
</template>

<script>
export default {
  name: 'IconMessage',
};
</script>

<style></style>
